import { useState, useRef, useEffect } from 'react';

var isChrome = !!window.chrome;
function useCompositionInput(_a) {
    var defaultValue = _a.defaultValue, value = _a.value, onCommit = _a.onCommit;
    var _b = useState(defaultValue || value || ''), inner_value = _b[0], setInnerValue = _b[1];
    var isOnComposition = useRef(false);
    useEffect(function () {
        (defaultValue === undefined || defaultValue == null) && setInnerValue(value || '');
    }, [value]);
    var onChange = function (e) {
        var newValue = e.target.value;
        setInnerValue(newValue);
        if (!isOnComposition.current) {
            onCommit(newValue);
        }
    };
    var onComposition = function (e) {
        if (e.type.toLowerCase() === 'compositionend') {
            isOnComposition.current = false;
            if (isChrome) {
                // chrome53 开始, onchange先于 compositionend 执行, 无法得到最终的value, 所以这里多执行一次
                onChange(e);
            }
        }
        else {
            isOnComposition.current = true;
        }
    };
    return { value: inner_value, onChange: onChange, onCompositionStart: onComposition, onCompositionEnd: onComposition };
}

export { useCompositionInput };
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 4
// module chunks = 0